import { Directive, ElementRef, HostListener, Input, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appInputRestrict]' 
})
export class InputRestrictDirective {
  @Input('appInputRestrict') regexPattern: string | undefined; 

  constructor(private el: ElementRef, @Optional() @Self() private ngControl: NgControl) {}

  @HostListener('input', ['$event']) onInput(event: Event) {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    var currentValue = inputElement.value;

    if (this.regexPattern) {
      const regex = new RegExp(this.regexPattern);
      while (!regex.test(currentValue) && currentValue.length != 0) {
        currentValue = currentValue.slice(0, -1);
        inputElement.value = currentValue;
      }
      this.ngControl?.control?.setValue(currentValue);
      this.ngControl?.control?.updateValueAndValidity();      
    }
  }
}